import { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import DashboardPage from "./components/pages/DashboardPage/DashboardPage";
import DashboardEquipment from "./components/pages/DashboardEquipment/DashboardEquipment";
import EquipmentPage from "./components/pages/EquipmentPage/EquipmentPage";
import "./App.css";
import SocketClient from "./clients/socket.client";
import { ConfirmationModalProvider } from "./services/ConfirmationModalService";
import ConfirmationModal from "./components/general/ConfirmationModal";
import LoginPage from "./components/pages/LoginPage/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import { http } from "./clients/http/http.client";
import { HTTP_ENDPOINTS, roleConfig } from "./clients/clients.constants";
import { setUser } from "./store/userSlice";
import AnalyticsWidgets from "./components/pages/DashboardEquipment/AnalyticsWidgets/AnalyticsWidgets";
import Loader from "./components/Inputs/Loader/Loader";

function AppWrapper() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const socket = SocketClient.getSocket();

  const [authenticated, setAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // This state will hold the computed default redirect path.
  const [defaultRedirect, setDefaultRedirect] = useState("/login");

  useEffect(() => {
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  const checkAuth = async () => {
    try {
      setIsLoading(true);
      const response = await http.client.get(HTTP_ENDPOINTS.USER_INFO);
      console.log("response", response);
      dispatch(setUser(response));
      setAuthenticated(true);

      // Compute the default redirect based on the user's roles.
      const userRoles = response.roles;
      // Prefer admin if available.
      let matchingRole = userRoles.includes("admin")
        ? "admin"
        : userRoles.find((role) => roleConfig[role]);
      if (matchingRole) {
        const redirectPath = roleConfig[matchingRole].defaultRedirect;
        setDefaultRedirect(redirectPath);
        console.log("Default redirect:", redirectPath);
        // If on the login page, navigate immediately.
        if (window.location.pathname === "/login") {
          navigate(redirectPath, { replace: true });
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Authentication error:", error);
      setAuthenticated(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className="App">
        <ConfirmationModalProvider>
          <Loader sx={{ width: "100vw", height: "100vh" }} />
        </ConfirmationModalProvider>
      </div>
    );
  }

  const allowedPaths = ["/login", "/dashboard", "/enrollment", "/asset-tracking"];

  return (
    <div className="App">
      <ConfirmationModalProvider>
        <Routes>
          <Route element={<ProtectedRoute allowedPaths={allowedPaths} />}>
            <Route path="/home" element={<DashboardPage />} />
            <Route path="/enrollment" element={<EquipmentPage />} />
            <Route path="/asset-tracking" element={<DashboardEquipment />} />
            {/*<Route path="/analytics" element={<AnalyticsWidgets />} />*/}
          </Route>
          {/* Here we use the computed defaultRedirect */}
          <Route
            path="*"
            element={
              authenticated ? (
                <Navigate to={defaultRedirect} replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="/" element={<Navigate to="/home" />} />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
        <ConfirmationModal />
      </ConfirmationModalProvider>
    </div>
  );
}

export default AppWrapper;
